import Navbar from './components/Navbar';
import Sidebar from './components/SidebarMini';
import Background from './components/Background';

import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Home, MyDeck, Monster } from './pages';
const App = () => {
  
  return (
    <>
      <Background />
      <BrowserRouter>
        <Navbar />
        <Sidebar />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/mydeck">
            <MyDeck />
          </Route>
          <Route path="/monster/:id">
            <Monster />
          </Route>
        </Switch>
      </BrowserRouter>
    </>
  )
}

export default App
